exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".footer__3FO2B{width:100%;text-align:center;margin-bottom:30px}.links__yoiCN{margin-top:5px}.links__yoiCN a{margin:0 5px;color:black}\n", "",{"version":3,"sources":["footer.module.scss"],"names":[],"mappings":"AAAA,eAAQ,UAAU,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,cAAO,cAAc,CAAC,gBAAS,YAAY,CAAC,WAAW","file":"footer.module.scss","sourcesContent":[".footer{width:100%;text-align:center;margin-bottom:30px}.links{margin-top:5px}.links a{margin:0 5px;color:black}\n"]}]);

// Exports
exports.locals = {
	"footer": "footer__3FO2B",
	"links": "links__yoiCN"
};